import React from "react";
import TechnicalFilesPage from "../components/TechnicalFiles/TechnicalFilesPage";
import { DarkModeContext } from "../contexts/DarkModeContext";

const TechnicalFilesPageWrapper = () => {
    const { isDarkMode } = React.useContext(DarkModeContext);

    return <TechnicalFilesPage isDarkMode={isDarkMode} />;
};

export default TechnicalFilesPageWrapper;

